<template>
  <div class="form-role">
    <v-text-field
      id="nameRole"
      v-model.trim="form.nameRole"
      :error-messages="NameRoleErrors"
      name="nameRole"
      outlined
      :disabled="loading"
      :label="$t('members.roleName')+'*'"
      @focus="$v.form.nameRole.$touch()"
      @blur="$v.form.nameRole.$touch()"
    />
    <v-text-field
      id="searchRole"
      v-model.trim="searchRole"
      name="searchRole"
      outlined
      :disabled="loading"
      :label="$t('members.searchPermission')"
    />
    <div v-if="loading">
      <v-progress-linear :indeterminate="true" />
      <div
        v-if="loadingCreateOrEdit"
        class="loading-description mt-6"
      >
        {{ $t('members.loadingMessage') }}
      </div>
    </div>
    <div v-else>
      <ul class="permission-list">
        <li
          v-for="(item, idx) in listPermissions"
          v-show="isShowSection(item.permissions)"
          :key="item.key"
        >
          <v-checkbox
            v-model="item.allSelected"
            :label="item.langName"
            hide-details
            :indeterminate="item.value.length !== 0 && item.value.length !== item.permissions.length"
            color="#0059FF"
            class="permission-list__name"
            @change="selectedAllCategory($event, item, idx)"
          />
          <ul
            v-if="item.permissions.length !== 0"
            class="permission-list__permissions"
          >
            <li
              v-for="permission in item.permissions"
              v-show="searchRole.length <= 2 || permission.langName.includes(searchRole)"
              :key="permission.id"
            >
              <input
                :id="permission.id"
                v-model="item.value"
                type="checkbox"
                class="permissions-checkbox"
                :value="permission.id"
                @change="selectedAllPermissions(idx)"
              >
              <label
                :for="permission.id"
                class="permissions-name"
              >{{ permission.langName }}</label> 
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

import PERMISSIONS_QUERY from "@/graphql/queries/Permissions.gql";
import ROLE_PERMISSIONS_QUERY from "@/graphql/queries/RolePermissions.gql";
import CREATE_ROLE_MUTATION from "@/graphql/mutations/CreateRole.gql";
import UPDATE_ROLE_MUTATION from "@/graphql/mutations/UpdateRole.gql";

  export default {
    name: "CreateOrEditRole",
    mixins: [validationMixin],
    props: {
      role: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        loading: true,
        loadingCreateOrEdit: false,
        form: {
          nameRole: ''
        },
        searchRole: '',
        listPermissions: []
      }
    },
    validations() {
      return {
        form: this.rules,
      };
    },
    computed: {
      ...mapGetters("whitelabel", ["getWhiteLabel"]),
      rules() {
        return {
          nameRole: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(50),
          },
        }
      },
      NameRoleErrors() {
        const errors = [];
        if (!this.$v.form.nameRole.$dirty) return errors;
        !this.$v.form.nameRole.required && errors.push(this.$t("globals.reqField"));
        !this.$v.form.nameRole.minLength &&
        errors.push(this.$t("globals.minError", {char: this.$v.form.nameRole.$params.minLength.min}));
        !this.$v.form.nameRole.maxLength &&
        errors.push(this.$t("globals.maxError", {char: this.$v.form.nameRole.$params.maxLength.max}));

        return errors;
      },
    },
    watch: {
      permissions(val) {
        if(val.length !== 0 && !this.role) {
          this.getListPermissions()
        }
      },
    },
    mounted() {
      if(this.role) {
        this.getPermissionRole();
        this.form.nameRole = this.role.name;
      }
    },
    methods: {
      getListPermissions() {
        this.listPermissions = this.permissions.map(item => {
          const permissions = item.permissions.map(item => {
            return {
              ...item,
              langName: this.$t(`members.permission.${item.name}`),
            }
          })
          return {
            ...item,
            permissions,
            langName: this.$t(`members.permission.${item.name}`),
            value: [],
            length: item.permissions.length,
            allSelected: false
          }
        });
      },
      getPermissionRole() {
        this.loading = true;
        const params = {
          whitelabel_uuid: this.getWhiteLabel.uuid,
          role_uuid: this.role.uuid
        }
        this.$apollo
          .query({
            query: ROLE_PERMISSIONS_QUERY,
            variables: params,
            fetchPolicy: "network-only",
          })
          .then(({loading, data}) => {
            if(!loading && data.rolePermissions.length !== 0) {
              this.listPermissions = data.rolePermissions.map(item => {
                const permissions = item.permissions.map(item => {
                  return {
                    ...item,
                    langName: this.$t(`members.permission.${item.name}`),
                  }
                });
                const accessRole = permissions.filter(item => item.connected).map(item => item.id);
                const allSelected = accessRole.length === permissions.length
                
                return {
                  ...item,
                  permissions,
                  langName: this.$t(`members.permission.${item.name}`),
                  value: accessRole,
                  length: item.permissions.length,
                  allSelected
                }
              });
              this.loading = loading;
            }
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
          });
      },
      selectedAllCategory(eventCheckbox, item, idx) {
        if(eventCheckbox) {
          this.listPermissions[idx].value = item.permissions.map(permission => permission.id);
        }
        if(!eventCheckbox) {
          this.listPermissions[idx].value = [];
        }
      },
      selectedAllPermissions(idx) {
        const getPermission = this.listPermissions[idx];
        if(getPermission.value.length === getPermission.length) {
          this.listPermissions[idx].allSelected = true;
        } else {
          this.listPermissions[idx].allSelected = false;
        }
      },
      save() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }
        const getAllPermissions = []
        this.listPermissions.forEach(item => {
          getAllPermissions.push(...item.value);
        });
        this.loadingCreateOrEdit = true;
        this.loading = true;
        this.$emit('setSavingRole', true);
        let params = {
          whitelabel_uuid: this.getWhiteLabel.uuid,
          name: this.form.nameRole,
          permissions: getAllPermissions
        };

        if(this.role) params.role_uuid = this.role.uuid;

        this.$apollo
          .mutate({
            mutation: this.role ? UPDATE_ROLE_MUTATION : CREATE_ROLE_MUTATION,
            variables: params
          })
          .then(data => {
            this.$emit('setSavingRole', false);
            this.$emit('editRoleBack', true);
            this.$emit('reloadRoles');
            this.loading = false;
            this.loadingCreateOrEdit = false;
            this.listPermissions = [];
            this.form.nameRole = '';
          })
          .catch(error => {
            this.errorHandler(error);
            this.loading = false;
            this.loadingCreateOrEdit = false;
          });
      },
      isShowSection(permissionArray) {
        if(this.searchRole.length > 2) {
          const isIncludes = permissionArray.filter(perm => perm.langName.includes(this.searchRole));
          if(isIncludes.length !== 0) {
            return true;
          }
          return false;
        }
        return true;
      }
    },
    apollo: {
      permissions: {
        query: PERMISSIONS_QUERY,
        fetchPolicy: 'network-only',
        variables() {
          return {
            whitelabel_uuid: this.getWhiteLabel.uuid,
          };
        },
        result({loading}) {
          this.loading = loading;
        },
        skip() {
          return this.role || !this.getWhiteLabel.uuid
        }
      },
    }
  }
</script>
<style lang="scss">
  .form-role {
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    .loading-description {
      font-size: 15px;
      font-style: normal;
      height: 18px;
      font-weight: 600;
    }
    .permission-list {
      list-style-type: none;
      padding: 0;
      li {
        margin-bottom: 24px;
      }
      &__name {
        padding: 0;
        font-size: 15px;
        font-weight: 600;
      }
      &__permissions {
        list-style-type: none;
        margin-left: 12px;
        padding-left: 22px;
        border-left: 1px solid var(--light-theme-surface-color-10, rgba(49, 57, 44, 0.10));
        li {
          display: flex;
          align-items: center;
          margin-top: 12px;
        }
        .permissions-checkbox {
          margin-right: 12px;
          width: 18px;
          min-width: 18px;
          height: 18px;
          accent-color: #0059FF;
        }
        .permissions-name {
          font-size: 13px;
          font-weight: 500;
        }
      }
    }
  }
</style>